/**
 * 提供浏览器端数据获取和缓存机制
 */
define('data/api', ['jquery', 'md5'], ($, md5) => {
    let cache = {};

    return {
        get: function get(opt) {
            let options = opt;

            const d = $.Deferred(); // eslint-disable-line

            if (typeof options === 'string') {
                options = { url: options };
            }

            options = options || {};
            options.url = this.getApiUrl(options.url);
            options.cache = options.cache || false;

            if (__DEVELOPMENT__) {
                console.log('data/api#get', options);
            }

            if (!options.url) {
                d.reject(new Error('cannot determine api url'));
            }

            const cacheKey = md5(options.url);
            if (options.cache && cache[cacheKey]) {
                d.resolve(cache[cacheKey]);
                return d.promise();
            }

            $.ajax({
                type: 'GET',
                dataType: options.dataType || 'json',
                url: options.url,
                data: options.data || {},
            }).then(data => {
                if (options.cache) {
                    cache[cacheKey] = data;
                }

                d.resolve(data);
            }).fail(err => {
                d.reject(err);
            });

            return d.promise();
        },

        getApiUrl: function getApiUrl(args) {
            if (args) {
                if (typeof args === 'string') {
                    return args;
                }

                if (typeof args === 'object' && args.c && args.m) {
                    return `/index.php?d=api&c=${args.c}&m=${args.m}`;
                }

                if (typeof args === 'object' && args.controller && args.method) {
                    return `/index.php?d=api&c=${args.controller}&m=${args.method}`;
                }
            }

            return '';
        },

        flushCache() {
            cache = {};
        },
    };
});
